import api from './api'

const BASE = '/management'

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '')
  )

const get = (path, params) => api.get(`${BASE}${path}`, { params: cleanParams(params) }).then((r) => r.data)
const post = (path, body) => api.post(`${BASE}${path}`, body).then((r) => r.data)
const put = (path, body) => api.put(`${BASE}${path}`, body).then((r) => r.data)
const del = (path) => api.delete(`${BASE}${path}`).then((r) => r.data)

let accessPromise = null
let accessToken = null

const managementService = {
  getAccess: () => get('/access'),

  /** Cached per auth token; cleared on failure so a later call can retry. */
  getAccessCached: () => {
    const token = localStorage.getItem('token')
    if (!accessPromise || accessToken !== token) {
      accessToken = token
      accessPromise = get('/access').catch((err) => {
        accessPromise = null
        throw err
      })
    }
    return accessPromise
  },
  clearAccessCache: () => { accessPromise = null },

  // MIS sections
  getSnapshot: (filters) => get('/snapshot', filters),
  getFinancialHealth: (filters) => get('/financial-health', filters),
  getSalesPipeline: (filters) => get('/sales-pipeline', filters),
  getProjectPortfolio: (filters) => get('/project-portfolio', filters),
  getResourceCapacity: (filters) => get('/resource-capacity', filters),
  getCustomerCollection: (filters) => get('/customer-collection', filters),
  getExpenseBudget: (filters) => get('/expense-budget', filters),
  getRenewals: (filters) => get('/renewals', filters),
  getRiskActions: (filters) => get('/risk-actions', filters),

  // Director review
  getDirectorReview: (filters) => get('/director-review', filters),
  saveDirectorReviewSnapshot: (payload) => post('/director-review/snapshots', payload),
  listDirectorReviewSnapshots: (params) => get('/director-review/snapshots', params),
  getDirectorReviewSnapshot: (id) => get(`/director-review/snapshots/${id}`),
  compareDirectorReviewSnapshots: (payload) => post('/director-review/compare', payload),

  // Risks
  listRisks: (params) => get('/risks', params),
  getRisk: (id) => get(`/risks/${id}`),
  createRisk: (data) => post('/risks', data),
  updateRisk: (id, data) => put(`/risks/${id}`, data),
  deleteRisk: (id) => del(`/risks/${id}`),

  // Actions
  listActions: (params) => get('/actions', params),
  getAction: (id) => get(`/actions/${id}`),
  createAction: (data) => post('/actions', data),
  updateAction: (id, data) => put(`/actions/${id}`, data),
  closeAction: (id, data) => post(`/actions/${id}/close`, data),
  deleteAction: (id) => del(`/actions/${id}`),

  // Decisions
  listDecisions: (params) => get('/decisions', params),
  createDecision: (data) => post('/decisions', data),
  updateDecision: (id, data) => put(`/decisions/${id}`, data),
  deleteDecision: (id) => del(`/decisions/${id}`),

  // Comments
  listComments: (params) => get('/comments', params),
  createComment: (data) => post('/comments', data),
  updateComment: (id, data) => put(`/comments/${id}`, data),
  deleteComment: (id) => del(`/comments/${id}`)
}

export default managementService
